import OrderState from '~/constants/common/OrderState';
import {
  useHasActiveCart,
  useUserPurchasing
} from '~/context/vdp/UserVehicleContext';
import useIsReservableVehicle from './useIsReservableVehicle';

export default function useHasCorePurchaseAndIsViewingReservable() {
  const hasActiveCart = useHasActiveCart();
  const purchasing = useUserPurchasing();
  const isReservable = useIsReservableVehicle();

  return (
    hasActiveCart &&
    purchasing?.orderState !== OrderState.Reserved &&
    isReservable
  );
}
